import { exportDataTableExcel } from 'utils/export-excel';
import { ExportExcelData } from 'store/practicas/types';
import { makeSelectTokenBearerToken } from 'store/oauth/selectors';
import { makeSelectUsername } from 'store/app/selectors';
import { ResponseFetcher } from './../../utils/fetcher/types';
import {
  getFilterAlumnoValidationRequest,
  getPhotosCountRequest,
  getPhotosRequest,
  postRejectPhotoRequest,
  postValidPhotoRequest,
} from './request';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from './../usuarios/selectors';
import { call, put, takeLatest, select, takeEvery } from 'redux-saga/effects';
import {
  getPhotos,
  getPhotosCount,
  setFilterAlumnoValidation,
  setGetAlumnsValidationPhotosRequestStatus,
  setPhotos,
  setPhotosCount,
  setPostRejectPhotoRequestStatus,
  setPostValidPhotoRequestStatus,
} from './actions';
import { RequestStatusTypes, TxtTypes } from 'consts';
import ActionTypes from './actionTypes';
import { addSingleQuotesToStudentsDniChain } from 'utils/practiceUtils';
import { RejectPhoto, ValidPhoto } from './types';
import { getInfoUsersRequestSaga } from 'store/app/sagas';
import { getTextEstadoFoto } from 'utils/stateUtils';
import { parseDate } from 'utils/parsePractices';
import { setLoading } from 'store/app/actions';
export default function* sagas() {
  yield takeLatest([ActionTypes.GET_PHOTOS], getPhotosGeneralRequestSaga);
  yield takeLatest(
    [ActionTypes.GET_PHOTOS_COUNT],
    getPhotosGeneralCountRequestSaga
  );

  yield takeEvery(
    ActionTypes.GET_ALUMNS_VALIDATIONPHOTOS_REQUEST,
    getFilterAlumnoValidationRequestSaga
  );

  yield takeEvery(
    ActionTypes.POST_PHOTO_REJECT_SELECTION,
    postRejectPhotoRequestSaga
  );

  yield takeEvery(
    ActionTypes.POST_PHOTO_VALID_SELECTION,
    postValidPhotoRequestSaga
  );

  yield takeLatest([ActionTypes.GET_EXCEL_PHOTOS], getExcelPhotosRequestSaga);
}

export function* getExcelPhotosRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(photosExcelRequestSaga, {
      ...params.payload.filter,
      elemInicio: -1,
      elemFin: -1,
      elemFinal: -1,
    });

    const EXPORT_EXCEL: ExportExcelData = {
      headerExcelFile: [],
      bodyExcelFile: [],
      headerColumsConfig: [],
      title: 'listado_fotos_' + new Date().getTime().toString(),
    };

    params.payload.excelConfig.literals.forEach((item) => {
      EXPORT_EXCEL.headerExcelFile.push(item.text);
      EXPORT_EXCEL.headerColumsConfig.push({
        label: item.text,
        key: item.text,
        width: 30,
      });
    });
    response.data.forEach((item) => {
      let textoActivo;
      let fechaProvisional = parseDate(item.FECHA_PROVISIONAL);
      if (item.ALUMNO_ACTIVO === 'S') {
        textoActivo = 'Activo';
      } else {
        textoActivo = 'Inactivo';
      }
      const itemArray = [
        item.ID_ALUMNO + ' - ' + item.nombre_parsed,
        textoActivo,
        item.CONSENTIMIENTO,
        fechaProvisional,
        getTextEstadoFoto(item.ESTADO_FOTOGRAFIA),
      ];

      EXPORT_EXCEL.bodyExcelFile.push(itemArray);
    });

    exportDataTableExcel(
      EXPORT_EXCEL.headerExcelFile,
      EXPORT_EXCEL.bodyExcelFile,
      EXPORT_EXCEL.headerColumsConfig,
      EXPORT_EXCEL.title
    );
  } catch (err) {
    console.error(err);
  }
}

export function* photosExcelRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    ...params,
  };
  payload.alumno =
    payload.alumnos !== ''
      ? addSingleQuotesToStudentsDniChain(payload.alumno)
      : payload.alumno;

  const informPhotosResponse: ResponseFetcher<any> = yield call(
    getPhotosRequest,
    payload
  );
  const informPhotos = informPhotosResponse.data;

  const alumnosIds = informPhotos.map((item) => item.ID_ALUMNO).join(',');
  const infoUsersResponse: ResponseFetcher<any> = yield call(
    getInfoUsersRequestSaga,
    alumnosIds
  );
  const infoUsers = infoUsersResponse.data;

  const informPhotosParsed: any[] = [];

  informPhotos.forEach((informe) => {
    const user: any = infoUsers.find(
      (user: any) => user.ID_USUARIO === informe.ID_ALUMNO
    );

    informPhotosParsed.push({
      ...informe,
      nombre_parsed: user?.NOMBRE_USUARIO || '',
    });
  });

  return {
    ok: true,
    data: informPhotosParsed,
  };
}

export function* postRejectPhotoRequestSaga(param) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: RejectPhoto = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      observacion: param.payload.observacion,
      fecha: param.payload.fecha as string,
      user: param.payload.user,
      profile: param.payload.profile,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<null> = yield call(
      postRejectPhotoRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(
        setPostRejectPhotoRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setPostRejectPhotoRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(`Error: ${ActionTypes.POST_PHOTO_REJECT_SELECTION}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* postValidPhotoRequestSaga(param) {
  try {
    const request = param.payload;
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: ValidPhoto = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      user: request.validate.user,
      profile: request.validate.profile,
      fecha: request.validate.fecha as string,
    };
    const bearerToken = yield select(makeSelectTokenBearerToken());
    const response: ResponseFetcher<null> = yield call(
      postValidPhotoRequest,
      payload,
      bearerToken
    );

    if (response.ok) {
      yield put(
        setPostValidPhotoRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
      yield put(getPhotos(request.filter));
      yield put(getPhotosCount(request.filter));
      setLoading(false);
    } else {
      yield put(
        setPostValidPhotoRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      yield put(getPhotos(request.filter));
      yield put(getPhotosCount(request.filter));
      throw new Error(`Error: ${ActionTypes.POST_PHOTO_VALID_SELECTION}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getPhotosGeneralRequestSaga(params) {
  try {
    const response: ResponseFetcher<any> = yield call(
      getPhotosRequestSaga,
      params.payload
    );
    if (response.ok) {
      yield put(setPhotos(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_PHOTOS}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getPhotosRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );
  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    ...params,
  };
  payload.alumno = addSingleQuotesToStudentsDniChain(payload.alumno);
  const response: ResponseFetcher<any> = yield call(getPhotosRequest, payload);

  return response;
}

export function* getPhotosGeneralCountRequestSaga(params) {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      ...params.payload,
    };
    payload.alumno = addSingleQuotesToStudentsDniChain(payload.alumno);
    const response: ResponseFetcher<any> = yield call(
      getPhotosCountRequest,
      payload
    );
    if (response.ok) {
      yield put(setPhotosCount(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_PHOTOS_COUNT}`);
    }
    // return response;
  } catch (err) {
    console.error(err);
  }
}

export function* getFilterAlumnoValidationRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );
    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
    };

    const response: ResponseFetcher<any> = yield call(
      getFilterAlumnoValidationRequest,
      payload,
      '' /* bearerToken, */
    );

    if (response.ok) {
      yield put(setFilterAlumnoValidation(response.data));
      yield put(
        setGetAlumnsValidationPhotosRequestStatus({
          status: RequestStatusTypes.Success,
          code: response.code,
          url: response.url,
        })
      );
    } else {
      yield put(
        setGetAlumnsValidationPhotosRequestStatus({
          status: RequestStatusTypes.Error,
          code: response.code,
          message: TxtTypes.TXT_DEFAULT_MESSAGE_ERROR,
          url: response.url,
        })
      );
      throw new Error(
        `Error: ${ActionTypes.GET_ALUMNS_VALIDATIONPHOTOS_REQUEST}`
      );
    }
  } catch (err) {
    console.error(err);
  }
}
